export const svgCopiedStyles = [
  'align-items',
  'background',
  'border',
  'border-color',
  'color',
  'display',
  'dominant-baseline',
  'fill',
  'fill-opacity',
  'flex-wrap',
  'font',
  'font-border-radius',
  'font-family',
  'font-size',
  'font-weight',
  'height',
  'line-height',
  'margin',
  'margin-bottom',
  'margin-left',
  'margin-right',
  'margin-top',
  'max-width',
  'min-width',
  'opacity',
  'overflow',
  'padding',
  'padding-bottom',
  'padding-left',
  'padding-right',
  'padding-top',
  'stroke',
  'stroke-dasharray',
  'stroke-linecap',
  'stroke-linejoin',
  'stroke-opacity',
  'stroke-width',
  'text-align',
  'text-anchor',
  'text-shadow',
  'vertical-align',
  'width',
  'paint-order',
  'cx',
  'cy',
  'r',
  'transform',
];
